import { createContext } from 'react';
export const ModalViewerContext = createContext({});
